module.exports = __webpack_public_path__ + "static/media/tejpal.5aed2d30.jpg";